import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AppConfig } from 'app/app.config';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CustomerService } from '../customer.service';
import { Observable, Subject } from 'rxjs';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoCustomer } from 'app/shared/models/customer/dto-customer.model';
import { IDtoCompany } from 'app/shared/models/organization/dto-company.model';
import { IDtoCustomerType } from 'app/shared/models/customer/dto-customer-type.model';
import { PositionService } from '../position.service';
import { IDtoPaymentConcept } from 'app/shared/models/position/dto-payment-concept.model';
import { IDtoCalculateSalary } from 'app/shared/models/position/dto-calculate-salary.model';
import { ModalCommissionComponet } from 'app/views/modales/position/commission/modal-commission.component';
import { IDtoCommission } from 'app/shared/models/position/dto-commission.model';
import { ModalVoucherComponet } from 'app/views/modales/position/voucher/modal-voucher.component';
import { IDtoVoucher } from 'app/shared/models/position/dto-voucher.model';
import { IDtoPosition } from 'app/shared/models/position/dto-position.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { ActivatedRoute } from '@angular/router';
import { WorkingDayService } from '../working-day.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { ModalMassiveUpdateComponet } from 'app/views/modales/position/massive-update/modal-massive-update.component';

@Component({
    selector: 'app-position',
    styleUrls: ['position.style.scss'],
    templateUrl: 'position.template.html'
})
export class PositionComponent implements OnDestroy, OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;

    public nav: any;
    private customer: IDtoCustomer;
    private action = 'add';
    private position: IDtoPosition;
    /**Modales */
    private modalRef: BsModalRef;
    /**Catalogos */
    private catalogProductJobs: Observable<IDtoCatalog[]>;
    private catalogIsrTypes: Observable<IDtoCatalog[]>;
    private catalogPositionStatus: Observable<IDtoCatalog[]>;
    private catalogPayrollTypes: Observable<IDtoCatalog[]>;
    private catalogPaymentForms: Observable<IDtoCatalog[]>;
    private catalogWorkdayTypes: Observable<IDtoCatalog[]>;
    private catalogPositionTypes: Observable<IDtoCatalog[]>;
    //private catalogWorkingDays: Observable<IDtoCatalog[]>;
    private paymentConcepts: IDtoPaymentConcept[];

    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private formPositionCalculation: FormGroup;
    private group = {};
    private commissions = new Array() as IDtoCommission[];
    private vouchers = new Array() as IDtoVoucher[];
    private daysFrecuency: number;

    private indexMedium: number;
    private monthDays: number = 0;
    @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
    @ViewChild('tab1', { static: false }) private tab1;
    public resetCustomerId: Subject<number> = new Subject<number>();
    public constructor(private modalService: BsModalService
        , private configGeneral: AppConfig
        , private formBuilder: FormBuilder
        , private customerService: CustomerService
        , private positionService: PositionService
        , private configurationService: ConfigurationService
        , private spinner: NgxSpinnerService
        , private route: ActivatedRoute
        , private workingDayService: WorkingDayService
        , private identityService: IdentityService) {
        this.nav = document.querySelector('nav.navbar');
        this.customer = {} as IDtoCustomer;
        this.customer.payCompany = {} as IDtoCompany;
        this.customer.customerType = {} as IDtoCustomerType;
        if (this.configurationService.isReady) {
            this.getCatalogs();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalogs();
            });
        }
    }

    ngOnInit(): any {
        this.nav.className += ' white-bg';
        this.fixedControlsInit();
        this.route.params.subscribe((params) => {
            if (params['id']) {
                setTimeout(() => {
                    this.getPosition(Number(params['id']));
                    this.action = params['action'];
                }, 2);

            }
        });
    }
    private receiveCustomer(customer: IDtoCustomer) {
        //this.catalogWorkingDays = Observable.of([] as IDtoCatalog[]);
        //this.formPositionCalculation.get('workingDayId').setValue(null);
        this.customer = customer;
        if (this.customer == undefined) {
            this.resetForm(true);
        } else {
            //this.catalogWorkingDays = this.workingDayService.getCatalogWorkingDays(this.customer.payCompanyId);
            // this.catalogWorkingDays.subscribe(x => {
            //     if (this.action == 'update') {
            //         this.formPositionCalculation.get('workingDayId').setValue(this.position.workingDayId);
            //     }
            // })
        }
    }
    private fixedControlsInit(): void {
        this.group['customerId'] = new FormControl(null, Validators.required);
        this.group['tradename'] = new FormControl(null, [Validators.required, Validators.maxLength(255)]);
        this.group['positionStatusId'] = new FormControl(null, Validators.required);
        this.group['productId'] = new FormControl(null, Validators.required);
        this.group['isrTypeId'] = new FormControl(null, Validators.required);
        this.group['payrollTypeId'] = new FormControl(null, Validators.required);
        this.group['paymentFormId'] = new FormControl(null, Validators.required);
        this.group['workdayTypeId'] = new FormControl(null, Validators.required);
        this.group['positionTypeId'] = new FormControl(null, Validators.required);
        //this.group['workingDayId'] = new FormControl(null, Validators.required);
        this.group['description'] = new FormControl(null, [Validators.maxLength(255)]);
        this.group['isMassive'] = new FormControl(false, Validators.required);
        this.group['projectId'] = new FormControl(null);
        this.formPositionCalculation = new FormGroup(this.group);
    }
    private getCatalogs(): void {
        this.getPaymentConcepts();
        this.catalogProductJobs = this.positionService.getCatalogProductJobs();
        this.catalogIsrTypes = this.positionService.getCatalogIsrTypes();
        this.catalogPositionStatus = this.positionService.getCatalogPositionStatus();
        this.catalogPayrollTypes = this.positionService.getCatalogPayrollTypes();
        this.catalogWorkdayTypes = this.positionService.getCatalogWorkdayTypes();
        this.catalogPaymentForms = this.positionService.getCatalogPaymentForms();
        this.catalogPositionTypes = this.positionService.getCatalogPositionTypes();
    }
    private initializeFormmPositionCalculation() {
        this.paymentConcepts.forEach(element => {
            this.group[element.variableName] = new FormControl(element.fixedValue);
        })
        this.formPositionCalculation = new FormGroup(this.group);
    }
    public ngOnDestroy(): any {
        this.nav.classList.remove('white-bg');
    }
    private getPosition(positionId: number): void {
        this.spinner.show()
        this.positionService.getPosition(positionId)
            .subscribe(
                (x) => {
                    this.position = x.data as IDtoPosition;
                    this.formPositionCalculation.patchValue(this.position.salaryCalculate);
                    this.setValues(this.position);
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private getPaymentConcepts(): void {
        this.positionService.getPaymentConcepts()
            .subscribe(
                (x) => {
                    this.paymentConcepts = x.data as IDtoPaymentConcept[];
                    let clasificationsFive = this.paymentConcepts.filter(x => x.clasificationId == 5);
                    let indexInit = this.paymentConcepts.indexOf(clasificationsFive[0]);
                    let divClasificationsFive = Math.round(clasificationsFive.length / 2);
                    this.indexMedium = indexInit + divClasificationsFive;

                    this.initializeFormmPositionCalculation();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private setValues(position: IDtoPosition): void {
        this.formPositionCalculation.get('customerId').setValue(position.customerId);
        this.formPositionCalculation.get('tradename').setValue(position.tradename);
        this.formPositionCalculation.get('positionStatusId').setValue(position.positionStatusId);
        this.formPositionCalculation.get('productId').setValue(position.productId);
        this.formPositionCalculation.get('isrTypeId').setValue(position.isrTypeId);
        this.formPositionCalculation.get('payrollTypeId').setValue(position.payrollTypeId);
        this.formPositionCalculation.get('paymentFormId').setValue(position.paymentFormId);
        this.formPositionCalculation.get('workdayTypeId').setValue(position.workdayTypeId);
        this.formPositionCalculation.get('positionTypeId').setValue(position.positionTypeId);
        //this.formPositionCalculation.get('workingDayId').setValue(position.workingDayId);
        this.formPositionCalculation.get('description').setValue(position.description);
        this.formPositionCalculation.get('projectId').setValue(position.projectCustomerId);

        this.position.backSalary = position.salaryCalculate.salary;
        this.commissions = position.commissions;
        this.vouchers = position.vouchers;
        this.resetCustomerId.next(position.customerId);
        this.catalogIsrTypes.subscribe(x => {
            this.daysFrecuency = +x.filter(x => x.id == position.isrTypeId)[0].additional;
        });
    }
    private submit(form: FormGroup): void {
        if (form.valid) {
            this.openModalMassiveUpdate();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(form);
        }
    }
    private save(): void {
        switch (this.action) {
            case 'add':
                this.addPosition();
                break;
            case 'update':
                this.updatePosition();
                break;
        }
    }
    private addPosition(): void {
        this.spinner.show();
        let position = this.mapValues();
        this.positionService.addPosition(position)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.position = x.data as IDtoPosition;
                        this.monthDays = position.salaryCalculate.monthDays;
                        this.formPositionCalculation.patchValue(position.salaryCalculate);
                        this.setValues(this.position);
                        this.action = 'update'
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.addModuleLog(this.position.id, 'new');
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide()
                },
                (errMessage) => {
                    this.configGeneral.newToast('Error', errMessage.messages, 'error');
                    this.spinner.hide()});
    }
    private updatePosition(): void {
        this.spinner.show();
        let position = this.mapValues();
        this.positionService.updatePosition(position)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.position = x.data as IDtoPosition;
                        this.formPositionCalculation.patchValue(position.salaryCalculate);
                        this.setValues(this.position)
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.addModuleLog(this.position.id, 'update');
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide()
                },
                (errMessage) => {
                    this.configGeneral.newToast('Error', errMessage.messages, 'error');
                    this.spinner.hide()});
    }
    private mapValues(): IDtoPosition {
        let position = {} as IDtoPosition;
        if (this.action === 'update') {
            position.id = this.position.id;
            position.isMassive = this.formPositionCalculation.controls['isMassive'].value;
            position.backSalary = this.position.backSalary;
            position.codeNom = this.position.codeNom;
        }
        position.productId = this.formPositionCalculation.controls['productId'].value;
        position.customerId = this.formPositionCalculation.controls['customerId'].value;
        position.isrTypeId = this.formPositionCalculation.controls['isrTypeId'].value;
        position.payrollTypeId = this.formPositionCalculation.controls['payrollTypeId'].value;
        position.paymentFormId = this.formPositionCalculation.controls['paymentFormId'].value;
        position.workdayTypeId = this.formPositionCalculation.controls['workdayTypeId'].value;
        position.positionTypeId = this.formPositionCalculation.controls['positionTypeId'].value;
        position.positionStatusId = this.formPositionCalculation.controls['positionStatusId'].value;
        //position.workingDayId = this.formPositionCalculation.controls['workingDayId'].value;
        position.tradename = this.formPositionCalculation.controls['tradename'].value;
        position.description = this.formPositionCalculation.controls['description'].value;
        position.projectCustomerId = this.formPositionCalculation.controls['projectId'].value;

        let values = this.formPositionCalculation.getRawValue() as IDtoCalculateSalary;
        values.uma = this.customer.minimumSalary;
        values.workRiskPercentage = this.customer.riskPremiumValue;
        values.payrollTaxPercentage = this.customer.payCompany.payrollTaxPercentage;
        values.agencyPercentage = this.customer.agencyPercentage;
        values.administrativeExpensesPercentage = this.customer.administrativeExpensesPercentage;
        values.commissionsList = this.commissions;
        values.vouchersList = this.vouchers;
        position.commissions = this.commissions;
        position.vouchers = this.vouchers;
        values.daysFrecuency = this.daysFrecuency;
        position.salaryCalculate = values;

        return position;
    }
    private monthlyCalculation(variable: string): number {
        let v = (document.getElementById(variable) as HTMLInputElement).value;
        return +v * this.monthDays;
    }
    private calculateSalary(): void {
        if (!this.formPositionCalculation.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formPositionCalculation);
            return;
        }
        let values = this.formPositionCalculation.getRawValue() as IDtoCalculateSalary;
        values.uma = this.customer.minimumSalary;
        values.workRiskPercentage = this.customer.riskPremiumValue;
        values.payrollTaxPercentage = this.customer.payCompany.payrollTaxPercentage;
        values.agencyPercentage = this.customer.agencyPercentage;
        values.administrativeExpensesPercentage = this.customer.administrativeExpensesPercentage;
        values.commissionsList = this.commissions;
        values.vouchersList = this.vouchers;
        values.daysFrecuency = this.daysFrecuency;
        this.positionService.calculateSalary(values)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        const v = x.data as IDtoCalculateSalary;
                        this.monthDays = v.monthDays;
                        this.formPositionCalculation.patchValue(v);
                        console.log(x.data)
                    } else {
                        this.configGeneral.newToast('Error', x.exception, 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private openModalCommission() {
        const initialState = {
            title: `Comisiones`,
            commissions: this.commissions,
            customerId: this.customer.id
        };
        this.modalRef = this.modalService.show(ModalCommissionComponet
            , Object.assign({ initialState }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.commissions = [...result];
                let sum: number = 0;
                this.commissions.forEach(a => sum += +a.value);
                this.formPositionCalculation.get('commissions').setValue(sum);
            } else {
                this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
            }
        });
    }
    private openModalVoucher() {
        const initialState = {
            title: `Vales`,
            vouchers: this.vouchers
        };
        this.modalRef = this.modalService.show(ModalVoucherComponet
            , Object.assign({ initialState }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.vouchers = [...result];
                let sum: number = 0;
                this.vouchers.forEach(a => sum += +a.value);
                this.formPositionCalculation.get('otherVouchers').setValue(sum);
            } else {
                this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
            }
        });
    }
    private touchedControls(form: FormGroup): void {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    private resetForm(reset: boolean): void {
        if(reset) {
            this.tab1.nativeElement.checked = true;
            this.customer = {} as IDtoCustomer
            this.initializeFormmPositionCalculation();
            this.fixedControlsInit();
            this.commissions = new Array() as IDtoCommission[];
            this.vouchers = new Array() as IDtoVoucher[];
            this.action = 'add';
            this.position = {} as IDtoPosition;
        }
    }
    private resetFormPartial(reset: boolean): void {
        if(reset) {
            this.initializeFormmPositionCalculation();
            this.fixedControlsInit();
            this.commissions = new Array() as IDtoCommission[];
            this.vouchers = new Array() as IDtoVoucher[];
            this.action = 'add';
            this.position = {} as IDtoPosition;
            this.formPositionCalculation.get('customerId').setValue(this.customer.id);
        }
    }
    private changePaymentForm(value: IDtoCatalog): void {
        switch (value.id) {
            case 1:
                let valMonthDays = this.paymentConcepts.filter(x => x.variableName == 'monthDays')[0].fixedValue;
                this.formPositionCalculation.get('monthDays').disable();
                this.formPositionCalculation.get('workdayTypeId').setValue(1);
                this.formPositionCalculation.get('workdayTypeId').disable();
                this.formPositionCalculation.get('monthDays').setValue(valMonthDays);
                break;
            case 2:
                this.formPositionCalculation.get('workdayTypeId').enable();
                this.formPositionCalculation.get('monthDays').enable();
                break;
        }
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Positions';
        dto.module = 'jobCreation';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private openModalMassiveUpdate(): void {
        this.modalRef = this.modalService.show(ModalMassiveUpdateComponet
            , Object.assign(this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result == true || result == false) {
                this.formPositionCalculation.get('isMassive').setValue(result);
                this.addSwal.title = 'Seguro que desea guardar la configuración del puesto.';
                this.addSwal.show();
            } else {
                this.configGeneral.newToast('Validación', 'Debe seleccionar si desea hacer actualiación de salario o no, para poder continuar', 'warning');
            }
        });
    }
}
